import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

export default {
  postApi: (bvModal, params, callbackSuccess, callbackFinally) => {
    return AppModel.post(
      'materials_and_equipment_aggregation/sheets',
      bvModal,
      params,
      callbackSuccess,
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('materials_and_equipment_aggregation_sheets', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/CreateMaterialsAndEquipmentAggregationSheetsModel.js